






























import {
  computed,
  defineComponent,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import packages from '@/table/deliveryNote/dividePackages';

import getDelivery from '@/gql/delivery/getDelivery.gql';
import divideDelivery from '@/gql/delivery/divideDelivery.gql';

interface BasedDelivery { id: number; packages: any }

const CommonModalWithDivideDelivery = defineComponent({
  components: {
    PrettyCheck,
  },
  props: {
    id: { default: -1 },
  },
  setup(props, { emit }) {
    const modal = ref(null);

    const forceRefresh: Ref<boolean> = ref(true);
    const delivery: Ref<BasedDelivery> = ref({
      id: -1,
      packages: [],
    });
    const { result: getDeliveryResult, loading } = useQuery(getDelivery, computed(() => ({
      id: props.id,
    })), () => ({
      fetchPolicy: 'network-only',
      enabled: props.id !== -1,
    }));
    const _delivery = useResult(getDeliveryResult, { id: -1, packages: [] }, (data: any) => ({
      ...data.delivery,
      packages: data.delivery.packages.map((item: any) => ({
        ...item,
        newCount: 0,
      })),
    }));
    watch(() => getDeliveryResult.value, () => {
      if (!loading.value && _delivery.value.id !== -1) {
        delivery.value = _delivery.value as any;
      }
    });

    function open() { (modal.value as any).open(); }
    function close() {
      forceRefresh.value = false;
      delivery.value = { id: -1, packages: [] };
      forceRefresh.value = true;
      emit('close');
      (modal.value as any).close();
    }

    const computedPackagesInput = computed(() => delivery.value.packages.filter((pack: any) => pack.newCount > 0).map((pack: any) => ({ id: pack.id, count: parseFloat(pack.newCount) })));

    const separatePackageMutation = useMutation(divideDelivery, () => ({
      variables: {
        id: props.id,
        dividePackages: computedPackagesInput.value,
        isDeliveryFailed: _delivery.value.status === 'NOT_SUCCESS' || _delivery.value.status === 'SOME_SUCCESS',
      },
      refetchQueries: ['getDeliveries', 'getDelivery'],
    }));
    function pendingToSeparateDeliveryPackages() {
      separatePackageMutation.mutate();
    }
    separatePackageMutation.onDone(() => {
      close();
    });

    const allowToSubmit = computed(() => {
      if (computedPackagesInput.value?.length === 0) return false;
      if (delivery.value.packages?.filter((pack: any) => parseFloat(pack.newCount) === parseFloat(pack.count)).length === delivery.value.packages?.length) return false;
      return true;
    });

    return {
      modal,
      open,
      close,

      forceRefresh,
      loading,
      packageTableOption: packages,

      delivery,

      pendingToSeparateDeliveryPackages,
      allowToSubmit,
    };
  },
});

export default CommonModalWithDivideDelivery;
